<div class="card-container">
  <app-transaction-summary-ribbon [state]="mapperTransactionState" [policyData]="payloadInEdit"
    (documentManagerHandler)="documentManagerHandler($event)">
  </app-transaction-summary-ribbon>
</div>

<!--<p>
  <a (click)="docuPanel(1)"><i class="anticon anticon-paper-clip"></i> Documents</a>
</p>-->

<!-- Pending Tasks ? -->
<div class="m-t-20" *ngIf="state=='adjudication'">
  <span class="clickable" (click)="pendingPanel(1)">
    <nz-alert nzType="warning" nzCloseable nzMessage="2 ongoing tasks for this claim" nzShowIcon>
    </nz-alert>
  </span>
</div>

<!-- Comments -->
<div class="m-t-20" *ngIf="state=='adjudication'">

  <div class="ant-alert ant-alert-info ant-alert-with-description" *ngIf="showLastNote">
    <i class="ant-alert-icon anticon anticon-read"></i>

    <span class="ant-alert-message">
      Note from <b>Ryan Reynolds [Adjudicator]</b>
    </span>
    <span class="ant-alert-description">
      <small class="d-b m-b-10">2 April 2019 at 3:30 PM (1 day ago)</small>
      Please verify document proofs submitted. Especially the bills from Sacred Hearts Hospital.
    </span>
    <div class="p-t-10 d-b">
      <a (click)="notesPanel(1)">View all Notes</a>
      &nbsp;
      <a (click)="showLastNote=false;">Close</a>
    </div>
  </div>

</div>

<!-- Tabs -->
<div class="m-t-20">

  <!--
    <nz-radio-group [(ngModel)]="nzTabPosition" style="float:right;">
      <label nz-radio-button [nzValue]="'top'">Horizontal</label>
      <label nz-radio-button [nzValue]="'left'">Vertical</label>
    </nz-radio-group>
  -->

  <nz-tabset [class.inputs-are-disabled]="mapperTransactionState == 'claimUWReferral' ||
  mapperTransactionState == 'claimReinsReferral'" style="height:auto" [nzTabPosition]="nzTabPosition"
    [(nzSelectedIndex)]="selectedIndex" (nzSelectChange)="log([$event])">

    <!-- INVESTIGATION (STATIC) Owner: Ganesh-->
    <nz-tab [nzTitle]="titleTmplBasicInvest" *ngIf="getTabVisibilityStatus('InvestigationDetails')">
      <ng-template #titleTmplBasicInvest>
        <i nz-icon nzType="safety"></i> Investigation Report
      </ng-template>

      <div class="tab-investigation" [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

        <!-- Tabset for TWO INVESTIGATORS -->
        <nz-tabset style="height:auto" [nzSize]="'large'">

          <nz-tab [nzTitle]="titleTmplInvestigator1">
            <ng-template #titleTmplInvestigator1>
              <strong class="d-b">Investigator 2: Elliot Henderson (YOU!)</strong>
              <p class="col-grey-dark m-b-5">
                Investigation ongoing
              </p>
            </ng-template>

            <div>
              <div class="tab-investigation"
                [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                <!-- Investigation Items -->

                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records
                    </h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                        [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                        [nzShowUploadList]="showUploadList">
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>
                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate
                    </h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                        [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                        [nzShowUploadList]="showUploadList">
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>

                <!-- Overall Summary -->

                <div class="heading-tab">
                  <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                </div>

                <div class="flexie-auto-grid">
                  <!-- Summary Textbox -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Summary</h3>
                    <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                  </div>
                  <!-- Summary : Final Verdict -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Verdict / Final Recommendation</h3>

                    <nz-radio-group [(ngModel)]="investiVerdict">
                      <span class="d-b p-t-b-10">
                        <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                      </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                      <span class="d-b p-t-b-10">
                        <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                      </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                    </nz-radio-group>
                  </div>
                </div>

              </div>
            </div>

          </nz-tab>

          <nz-tab [nzTitle]="titleTmplInvestigator2">
            <ng-template #titleTmplInvestigator2>
              <strong class="d-b">Investigator 1: Kevin Fergie</strong>
              <p class="col-green m-b-5">
                Investigation Complete
              </p>
            </ng-template>

            <div class="inputs-are-disabled">
              <div class="tab-investigation"
                [ngClass]="{'inputs-are-disabled': !permissions.investigation_report.edit}">

                <!-- Investigation Items -->

                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item I: Hospital Records
                    </h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                        [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                        [nzShowUploadList]="showUploadList">
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>
                <div class="investigation-item">
                  <div class="heading-tab">
                    <h3 class="heading"><i nz-icon nzType="file-unknown"></i> Investigation Item II: Death Certificate
                    </h3>
                  </div>
                  <div class="flexie-auto-grid">
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Observations</h4>
                      <textarea nz-input cols="30" rows="6" placeholder="Enter your observations..."></textarea>
                    </div>
                    <div class="flex-self-vert-start">
                      <h4 class="p-b-10">Supporting Documents <a (click)="docuPanel(1)">[Manage]</a></h4>
                      <nz-upload nzAction="https://jsonplaceholder.typicode.com/posts/" nzListType="picture-card"
                        [(nzFileList)]="defaultUploadsList" [nzShowButton]="defaultUploadsList.length < 3"
                        [nzShowUploadList]="showUploadList">
                        <i nz-icon nzType="plus" nzTheme="outline"></i>
                        <div class="ant-upload-text">Upload</div>
                      </nz-upload>
                    </div>
                  </div>
                </div>

                <!-- Overall Summary -->

                <div class="heading-tab">
                  <h3 class="heading"><i nz-icon nzType="file-text"></i> Overall summary of investigation</h3>
                </div>

                <div class="flexie-auto-grid">
                  <!-- Summary Textbox -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Summary</h3>
                    <textarea nz-input cols="30" rows="6" placeholder="Enter your summary ..."></textarea>
                  </div>
                  <!-- Summary : Final Verdict -->
                  <div class="flex-self-vert-start">
                    <h3 class="heading">Verdict / Final Recommendation</h3>

                    <nz-radio-group [(ngModel)]="investiVerdict">
                      <span class="d-b p-t-b-10">
                        <label nz-radio nzValue="A"><span class="f-w-600 col-green">OK to proceed</span></label>
                      </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio
                             nzValue="B"><span class="f-w-600 col-orange">Proceed with caution / More investigation
                        required</span></label>
                      </span>-->
                      <span class="d-b p-t-b-10">
                        <label nz-radio nzValue="C"><span class="f-w-600 col-red">Do not proceed</span></label>
                      </span>
                      <!--<span class="d-b p-t-b-10">
                      <label nz-radio nzValue="O">
                        Other...
                        <input type="text" nz-input *ngIf="investiVerdict == 'O'" style="width: 100px; margin-left: 10px;" />
                      </label>
                      </span>-->
                    </nz-radio-group>
                  </div>
                </div>

              </div>
            </div>

          </nz-tab>

        </nz-tabset>

      </div>

    </nz-tab>

    <!-- BASIC DETAILS -->
    <nz-tab [nzTitle]="titleTmplBasicDtl" *ngIf="getTabVisibilityStatus('BasicDetails')"
      (nzSelect)="log(['select', tab])" (nzClick)="log(['click', tab])" (nzDeselect)="log(['deselect', tab])">
      <ng-template #titleTmplBasicDtl>
        <i nz-icon nzType="file-text"></i> Basic Details
      </ng-template>
      <app-claims-basic-details (componentOutput)="_BaseEmitHandler($event, 'ClaimsBasicDetailsComponent')"
        [inputDataForEdit]="_inputClaimsBasicDetailsComponent" [transactionState]="mapperTransactionState">
      </app-claims-basic-details>

      <!-- POLICY/Policies -->
      <app-captured-policy-list [policyList]="policyListFetchedFromServer"
        (componentOutput)="_BaseEmitHandler($event, 'CapturedPolicyListComponent')"
        (openModal)="modSearchCustOrPolicy=true;" [inputDataForEdit]="_inputCapturedPolicyListComponent">
      </app-captured-policy-list>

      <!-- [inputDataForEdit]="_inputCapturedPolicyListComponent"  -->
      <!-- Police Station / FIR Details -->
      <app-police-details *ngIf="appMetadataHandler['enablePoliceDetails']"></app-police-details>



    </nz-tab>

    <!-- INSURED DETAILS -->
    <nz-tab [nzTitle]="titleTmplLifeIns" *ngIf="getTabVisibilityStatus('InsuredDetails')">
      <ng-template #titleTmplLifeIns>
        <i nz-icon nzType="heart"></i> Insured Details
      </ng-template>

      <app-insured-details (componentOutput)="_BaseEmitHandler($event, 'InsuredDetailsComponent')"
        [inputDataForEdit]="_inputAllClientListComponent"></app-insured-details>

    </nz-tab>

    <!-- NOMINEE & CLAIMANT DETAILS -->
    <nz-tab [nzTitle]="titleTmplClaimant" *ngIf="getTabVisibilityStatus('NomineeClaimantDetails')">
      <ng-template #titleTmplClaimant>
        <i nz-icon nzType="team"></i> Nominee/Claimant Details
      </ng-template>

      <!-- Nominee -->

      <app-captured-client-list captureRole="NOMINEE" (clientEmitterToCopy)="updateClientList($event,'NOMINEE')"
        [allowClientToBeCopied]="TRUEVALUE" [operationMode]="MULTI" [clientList]="nomineeDataSet"
        (openSearchModal)="modSearchCustomer=true"
        (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentNOMINEE')"
        (emittedClient)="_EmittedClientHandler($event, 'CLAIMANT')" [inputDataForEdit]="_inputAllClientListComponent">
      </app-captured-client-list>

      <!-- Claimant -->

      <app-captured-client-list captureRole="CLAIMANT" [operationMode]="SINGLE" [clientList]="claimantDataSet"
        [allowClientToBeCopied]="FALSEVALUE" [enableCopy]="enableCopyOfClaimantAsNominee"
        [copySource]="copySourceForClaimant" sourceRole="NOMINEE" (openSearchModal)="modSearchCustomerClaimant=true"
        (componentOutput)="_BaseEmitHandler($event, 'CapturedClientListComponentCLAIMANT')"
        (updateClientList)="updateClientList($event,'CLAIMANT')" [inputDataForEdit]="_inputAllClientListComponent">
      </app-captured-client-list>


      <!-- <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="user" nzTheme="outline"></i> Claimant</h3>
        <div>

          <label nz-checkbox nzValue="true" [(ngModel)]="claimantSameAsNominee">
            Claimant same as Nominee
          </label>
          <button *ngIf="!claimantSameAsNominee" nz-button nzType="primary" (click)="modSearchCustomerClaimant=true">Search /
            Add Claimant</button>
          <button *ngIf="claimantSameAsNominee" disabled nz-button nzType="primary">Search / Add Claimant</button>
        </div>
      </div> -->
      <!-- <div class="search-results m-t-20">
      <nz-table  [nzShowPagination]="false"  #clientSearchTable [nzData]="claimantDataSet">
          <thead>
            <tr>
              <th>Customer No</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>DOB</th>
              <th>Gender</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of clientSearchTable.data">
                <td>{{data.clientNum}}</td>
                <td>{{data.firstName}}</td>
                <td>{{data.lastName}}</td>
                <td>{{getDateString(data.dateOfBirth)}}</td>
                <td>{{data.intimationNum}}</td>
              <td><a nz-popconfirm nzTitle="Remove customer from intimation?" nzOkText="Remove"
                  nzCancelText="Cancel" (nzOnConfirm)="removeClaimant(data,clientSearchTable.data,'clientNum')">Remove</a></td>
            </tr>
          </tbody>
        </nz-table>
      </div> -->

    </nz-tab>

    <!-- HOSPITAL DETAILS -->
    <nz-tab *ngIf="appMetadataHandler['enableHospitalTabInAllTransaction']" [nzTitle]="titleTmplHosp2">
      <ng-template #titleTmplHosp2>
        <i nz-icon nzType="medicine-box"></i> Hospitalization Details
      </ng-template>
      <div [ngClass]="{'inputs-are-disabled': !permissions.hospitalization.edit}">

        <div class="heading-tab">
          <h3 class="heading"><i nz-icon nzType="medicine-box" nzTheme="outline"></i> Hospitalization Details</h3>
          <button nz-button nzType="primary" (click)="modHospitalizationDetails=true">Add Hospitalization
            Details</button>
        </div>
        <!-- <app-ui-nested-table></app-ui-nested-table> -->
      </div>
    </nz-tab>

    <!-- TODO Owner: Ramesh - BANK DETAILS -->
    <!-- TODO Owner: Ramesh: Give out Data from Multicapture Bank Details -->
    <nz-tab [nzTitle]="titleTmplBank" *ngIf="getTabVisibilityStatus('BankDetails')"
      [class.inputs-are-disabled]="mapperTransactionState == 'claimInvestigation' || mapperTransactionState == 'claimAdjudication'">
      <ng-template #titleTmplBank>
        <i nz-icon nzType="bank"></i> Bank Details
      </ng-template>
      <div>
        <app-multicapture-bank-details [IO]="payloadInEdit" [inputDataForEdit]="_inputMulticaptureBankDetailsComponent"
          [transactionState]="mapperTransactionState"
          (componentOutput)="_BaseEmitHandler($event, 'MulticaptureBankDetailsComponent')">
        </app-multicapture-bank-details>
      </div>

    </nz-tab>

    <!-- PAYOUT DETAILS TODO Owner: Ramesh -->
    <nz-tab [nzTitle]="titleTmplPayoutDetails" *ngIf="getTabVisibilityStatus('PayoutDetails')">
      <ng-template #titleTmplPayoutDetails>
        <i nz-icon nzType="dollar"></i> Payout Details
      </ng-template>

      <app-payout-details [policyData]="payloadInEdit"></app-payout-details>

    </nz-tab>

    <!-- BENEFIT Owner: Ramesh-->
    <nz-tab [nzTitle]="titleTmplBenefit" *ngIf="getTabVisibilityStatus('Benefit')">
      <ng-template #titleTmplBenefit>
        <i nz-icon nzType="wallet"></i> Benefit
      </ng-template>

      <app-claims-benefit [IO]="_inputClaimsBenefitComponent"
        (componentOutput)="_BaseEmitHandler($event, 'ClaimsBenefitComponent')" transaction="benefit">
      </app-claims-benefit>

    </nz-tab>

    <!-- CLAIM DECISION Owner: Ramesh -->
    <nz-tab [nzTitle]="titleTmplDecision" *ngIf="getTabVisibilityStatus('ClaimDecision')">
      <ng-template #titleTmplDecision>
        <i nz-icon nzType="exception"></i> Claim Decision
      </ng-template>
      <app-claim-decision [inputDataForEdit]="_inputClaimDecisionComponent" [transactionState]="mapperTransactionState"
        (componentOutput)="_BaseEmitHandler($event, 'ClaimDecisionComponent')"
        [DOName]="_getDOName(mapperTransactionState)"></app-claim-decision>


    </nz-tab>

    <!-- PAYMENT BREAKUP Owner: Ganesh -->
    <nz-tab [nzTitle]="titleTmplPayout" *ngIf="getTabVisibilityStatus('PaymentBreakup')">
      <ng-template #titleTmplPayout>
        <i nz-icon nzType="audit"></i> Payment Breakup
      </ng-template>


      <app-claims-payment-breakup [IO]="payloadInEdit"
        (componentOutput)="_BaseEmitHandler($event, 'ClaimsPaymentBreakupComponent')"
        [inputDataForEdit]="_inputMulticaptureBankDetailsComponent" [transactionState]="mapperTransactionState">
      </app-claims-payment-breakup>
    </nz-tab>

    <!-- OTHER POLICY DETAILS  (STATIC) Owner: Ramesh-->
    <!-- Analytics tab shifted in Ribbon -->
    <!-- <nz-tab [nzTitle]="titleTmplAnltix" *ngIf="mapperTransactionState !== 'claimIntimation'">
      <ng-template #titleTmplAnltix>
        <i nz-icon nzType="dot-chart"></i> Analytics
      </ng-template>

      <div [ngClass]="{'inputs-are-disabled': !permissions.analytics.edit}">

        <app-ui-analytics-tab mode="tab"></app-ui-analytics-tab>
      </div>

    </nz-tab> -->



  </nz-tabset>
</div>

<!-- Save/Actions Footer -->
<ng-container *ngIf="transactionMasterUpdateControl">
  <div *ngIf="TransactionState!=='claimIntimation'" class="card-summary-data-footer __data-footer-primary">
    <div>
      <nz-dropdown class="m-r-10" [nzPlacement]="'topLeft'">
        <button nz-button [nzType]="'danger'" nz-dropdown>Reverse Claim<i nz-icon nzType="down"></i></button>
        <ul nz-menu>
          <li nz-menu-item (click)="showConfirm('Intimation')">
            <a>Reverse to Intimation</a>
          </li>
          <li nz-menu-item (click)="showConfirm('Registration')">
            <a>Reverse to Registration</a>
          </li>
        </ul>
      </nz-dropdown>

    </div>
    <div>

      <!-- <button *ngIf="payloadInEdit" nz-button class="m-r-10" [nzType]="'danger'">Reject</button> -->
      <nz-dropdown class="m-r-10" [nzPlacement]="'topLeft'">
        <button nz-button nz-dropdown>Actions<i nz-icon nzType="down"></i></button>

        <ul nz-menu>
          <li nz-menu-item *ngIf="mapperTransactionState != 'claimUWReferral'
              && mapperTransactionState != 'claimReinsReferral'" (click)="attemptForTransaction('submit')">
            <a>Submit</a>
          </li>
          <ng-container *ngIf="mapperTransactionState == 'claimRegistration'
                || mapperTransactionState == 'claimAdjudication'">
            <li *ngFor="let item of (lookup$.roleUsers | async) as roleUsersLookup; trackBy:item?.lookupKey"
              nz-menu-item (click)="referOrSubmitMode(item?.lookupKey)"><a>{{item?.lookupValue}}</a></li>
          </ng-container>
          <ng-container *ngIf="mapperTransactionState == 'claimInvestigation'">
            <li nz-menu-item><a>Submit Interim Report</a></li>
            <li nz-menu-item><a>Submit Final Report</a></li>
          </ng-container>
        </ul>
      </nz-dropdown>
      <button *ngIf="mapperTransactionState == 'claimUWReferral'
          || mapperTransactionState == 'claimReinsReferral'" nz-button class="m-r-10" [nzType]="'success'">Close
        Referral
        Task</button>
      <button nz-button class="m-r-10" [nzType]="'success'" (click)="attemptForTransaction('save')">Save</button>
    </div>
  </div>
  <div *ngIf="TransactionState==='claimIntimation'" class="card-summary-data-footer __data-footer-primary">
    <div>
      <button *ngIf="payloadInEdit" nz-button [nzType]="'danger'" (click)="modRejectIntimation=true;">Reject
        Intimation</button>
    </div>
    <div>
      <button nz-button class="m-r-10" [nzType]="'success'" (click)="attemptForTransaction('submit')">Submit</button>
      <button nz-button class="m-r-10" [nzType]="'primary'" (click)="attemptForTransaction('save')">Save</button>
    </div>
  </div>
</ng-container>



<div
  *ngIf="((payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0) || (_UIErrorList && _UIErrorList.length > 0))"
  class="error-panel" [ngClass]="{'error-panel-collapsed': errPanelCollapsed}">

  <!-- Heading -->
  <div class="flexie-auto-grid clickable p-b-5" (click)="errorPanelToggle()">
    <div>
      <h4 class="col-red">Exceptions</h4>
    </div>
    <div class="text-a-right d-b">
      <i *ngIf="!errPanelCollapsed" class="anticon anticon-down"></i>
      <i *ngIf="errPanelCollapsed" class="anticon anticon-up"></i>
    </div>
  </div>

  <!-- Errors List -->
  <div>
    <ng-container
      *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length > 0">

      <strong class="col-grey-dark">Validation Exceptions</strong>
      <ul class="error-list">
        <li *ngFor="let exception of payloadInEdit['exceptionDOList']">
          <span>{{exception?.exceptionType}} : {{exception?.exceptionMessage}}</span>
        </li>
        <div *ngIf="payloadInEdit && payloadInEdit['exceptionDOList'] && payloadInEdit['exceptionDOList'].length == 0">
          No
          Exceptions found</div>
      </ul>

    </ng-container>


    <ng-container *ngIf="_UIErrorList && _UIErrorList.length > 0">

      <strong class="col-grey-dark">Invalid Data</strong>
      <ul class="error-list">
        <li *ngFor="let error of _UIErrorList">
          <span>{{error?.fieldNameDescription}} : {{error?.errorMsg}}</span>
        </li>
        <div *ngIf="_UIErrorList && _UIErrorList.length == 0">No
          Exceptions found</div>
      </ul>

    </ng-container>

    <!-- <strong class="col-grey-dark">Business Exceptions</strong>
    <ul class="error-list">
      <div>No Exceptions found</div>
    </ul> -->
  </div>

  <!-- View all -->
  <!-- <a (click)="errDetailsPanel(1)" class="d-b col-grey-dark p-t-b-5 b-1 text-a-center">View All</a> -->

</div>


<!-- MODALS -->

<nz-modal [(nzVisible)]="modInvtgVis" [nzTitle]="modalTitle" (nzOnCancel)="modInvtgVis=false" (nzOnOk)="refertoUser()"
  nzOkText="Refer" nzWidth="600px">
  <ng-container *nzModalContent>
    <div *ngIf="modInvtgVis">

      <div class="flex flex-horiz-space-bw">
        <h4>Enter your Notes</h4>
        <nz-dropdown *ngIf="reffrelUserType == 'INVESTIGATOR'" [nzPlacement]="'bottomRight'">
          <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
          <ul nz-menu>
            <li nz-menu-item (click)="noteCannedReply(0)">Please have a look at the ...</li>
            <li nz-menu-item (click)="noteCannedReply(1)">Requesting additional investigation ...</li>
            <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
            <nz-divider class="dd-extra-hr"></nz-divider>
            <li nz-menu-item>Manage Canned Replies</li>
          </ul>
        </nz-dropdown>
      </div>
      <textarea *ngIf="reffrelUserType == 'INVESTIGATOR'" rows="2" nz-input [(ngModel)]="note"></textarea>
      <textarea *ngIf="reffrelUserType != 'INVESTIGATOR'" rows="5" nz-input [(ngModel)]="note"></textarea>

      <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Investigate:</h4>
      <nz-select nzShowSearch nzMode="tags" *ngIf="reffrelUserType == 'INVESTIGATOR'" style="width: 100%;"
        [ngModel]="'Hospital Records'">
        <nz-option nzLabel="Hospital Records" nzValue="Hospital Records"> </nz-option>
        <nz-option nzLabel="Death Certificate" nzValue="Death Certificate"> </nz-option>
        <nz-option nzLabel="Cross-check with Doctor" nzValue="Cross-check with Doctor"> </nz-option>
      </nz-select>


      <h4 class="d-b m-t-20" *ngIf="reffrelUserType == 'INVESTIGATOR'">Attach Files/Documents</h4>

      <!-- Upload table -->
      <nz-table *ngIf="reffrelUserType == 'INVESTIGATOR'" #basicTable [nzData]="dataSet" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Type</th>
            <th>Comment</th>
            <th>Document</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Claim Form</td>
            <td>Please check this in detail</td>
            <td><a>fc_023_scan.pdf</a></td>
            <td>
              <!-- Actions -->
              <span class="m-r-10"><i nz-icon nzType="eye" nzTheme="outline"></i></span>
              <span><i class="anticon anticon-delete col-red"></i></span>
            </td>
          </tr>
        </tbody>
      </nz-table>
      <a *ngIf="reffrelUserType == 'INVESTIGATOR'">Add more</a>



      <h4 class="d-b m-t-20">Assign to</h4>
      <!-- <nz-select nzShowSearch class="w-100-pc"  nzAllowClear nzPlaceHolder="Select a person">
      <nz-option nzLabel="Jack Nicholson (Golden Bay Area)" nzValue="1"></nz-option>
      <nz-option nzLabel="Lucy Liu (Hypercity Area)" nzValue="2"></nz-option>
      <nz-option nzLabel="Tom Hardy (New Delhi Area)" nzValue="3"></nz-option>
    </nz-select> -->
      <nz-select nzShowSearch id="eventType" style="width: 100%" [(ngModel)]="assigneeUser">
        <nz-option *ngFor="let item of (lookup$.csrUsersUID | async) as eventTypeCdLookup; trackBy:item?.lookupKey"
          [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupValue"></nz-option>
      </nz-select>
    </div>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modalCorrespNew" nzTitle="New Correspondence" (nzOnCancel)="modalCorrespNew=false"
  (nzOnOk)="modalCorrespNew=false" nzOkText="Send" nzWidth="75%" nzZIndex="=1400">
  <ng-container *nzModalContent>
    <div *ngIf="modalCorrespNew">

      <nz-radio-group [(ngModel)]="correspType" [nzButtonStyle]="'solid'" [nzSize]="'default'">
        <label nz-radio-button nzValue="email"><i nz-icon nzType="mail" nzTheme="outline"></i> Email</label>
        <label nz-radio-button nzValue="sms"><i nz-icon nzType="mobile" nzTheme="outline"></i> SMS</label>
        <label nz-radio-button nzValue="pdf"><i nz-icon nzType="file-pdf" nzTheme="outline"></i> PDF</label>
      </nz-radio-group>


      <div *ngIf="'email'==correspType">
        <h4 class="d-b m-t-20">To</h4>
        <!-- Multi emails; ENTER to add new entry -->
        <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'liam@thehemsworths.com'">
          <nz-option nzLabel="liam@thehemsworths.com" nzValue="liam@thehemsworths.com"></nz-option>
          <nz-option nzLabel="chris@thehemsworths.com" nzValue="chris@thehemsworths.com"></nz-option>
          <nz-option nzLabel="robert@thehemsworths.com" nzValue="robert@thehemsworths.com"></nz-option>
        </nz-select>


        <h4 class="d-b m-t-20">Content</h4>

        <angular-editor [(ngModel)]="correspondenceRichText"></angular-editor>


        <h4 class="d-b m-t-20">Attach Files/Documents</h4>

        <!-- Upload table -->
        <nz-upload nzType="drag" [nzMultiple]="true" [nzLimit]="2"
          nzAction="https://jsonplaceholder.typicode.com/posts/" (nzChange)="handleFileUpload($event)">
          <p class="ant-upload-drag-icon">
            <i nz-icon nzType="inbox" class="anticon anticon-inbox"></i>
          </p>
          <p class="ant-upload-text">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibited from uploading internal company data or other
            confidential data
          </p>
        </nz-upload>


      </div>

      <div *ngIf="'sms'==correspType">
        <h4 class="d-b m-t-20">To (Mobile Numbers)</h4>
        <!-- Multi phone nos; ENTER to add new entry -->
        <nz-select nzShowSearch nzMode="tags" style="width: 100%;" [ngModel]="'9800560098'">
          <nz-option nzLabel="9800560098" nzValue="9800560098"> </nz-option>
        </nz-select>

        <h4 class="d-b m-t-20">Message</h4>
        <textarea nz-input value=""></textarea>

      </div>
    </div>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modSubmit" nzTitle="Submit" (nzOnCancel)="modSubmit=false" (nzOnOk)="modSubmit=false"
  nzOkText="Submit">
  <ng-container *nzModalContent>
    <div *ngIf="modSubmit">

      <h4>I have verified</h4>
      <span class="d-b p-t-b-10"><label nz-checkbox>Documents are in place</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Proofs matches with records</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Verified against discrepancies in claim</label></span>
      <span class="d-b p-t-b-10"><label nz-checkbox>Verified claim amount</label></span>

      <div class="m-t-20">
        <h4 class="d-i-b m-r-10">Logged in as</h4>
        <nz-avatar nzSize="small" nzIcon="user"></nz-avatar>&nbsp;
        John Doe
      </div>

    </div>


  </ng-container>
</nz-modal>

<!-- Search Policy or Client -->
<nz-modal [(nzVisible)]="modSearchCustOrPolicy" nzTitle="Search / Add Policy" (nzOnCancel)="modSearchCustOrPolicy=false"
  (nzOnOk)="searchPolicyClientOk()" nzOkText="Add" nzWidth="75%">
  <ng-container *nzModalContent>
    <app-generic-search *ngIf="modSearchCustOrPolicy" searchMode="policySearchOnlyBasedOnClientOrPolicyData"
      (componentOutput)="getPolicyList($event)">
    </app-generic-search>
  </ng-container>
</nz-modal>

<!-- Search Client -->
<nz-modal [nzFooter]="ClientCaptureFooter" [nzClosable]="enableModalClose" [nzMaskClosable]="enableModalClose"
  [(nzVisible)]="modSearchCustomer" nzTitle="Search / Add Client" (nzOnCancel)="modSearchCustomer=false"
  (nzOnOk)="pingToClientSearchForNominee()" nzOkText="Select" nzWidth="75%">
  <ng-container *nzModalContent>
    <app-generic-search *ngIf="modSearchCustomer" searchMode="customerSearchOrCapture" captureRole="NOMINEE"
      (componentOutput)="getNominee($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </ng-container>
</nz-modal>

<!-- Serch Claimant -->
<nz-modal [nzFooter]="ClientCaptureFooter" [(nzVisible)]="modSearchCustomerClaimant" nzTitle="Search / Add Client"
  (nzOnCancel)="modSearchCustomerClaimant=false" (nzOnOk)="pingToClientSearchForClaimant()" nzOkText="Select"
  nzWidth="75%">
  <ng-container *nzModalContent>
    <app-generic-search *ngIf="modSearchCustomerClaimant" searchMode="customerSearchOrCapture" captureRole="CLAIMANT"
      (componentOutput)="getClaimant($event)" (enableFooter)="setFooter($event)"></app-generic-search>
  </ng-container>
</nz-modal>



<!-- Rejection -->
<nz-modal [(nzVisible)]="modRejectIntimation" nzTitle="Reject Intimation" (nzOnCancel)="modRejectIntimation=false"
  (nzOnOk)="modRejectIntimation=false" nzOkText="Reject" nzWidth="600px">
  <ng-container *nzModalContent>
    <div *ngIf="modRejectIntimation">

      <div class="flex flex-horiz-space-bw">
        <h4>Reason for Rejection</h4>
        <nz-dropdown [nzPlacement]="'bottomRight'">
          <a nz-dropdown class="col-grey-dark">Canned Replies <i nz-icon nzType="down"></i></a>
          <ul nz-menu>
            <li nz-menu-item (click)="noteCannedReply(2)">Required Documents are not in place ...</li>
            <nz-divider class="dd-extra-hr"></nz-divider>
            <li nz-menu-item>Manage Canned Replies</li>
          </ul>
        </nz-dropdown>
      </div>
      <textarea rows="2" nz-input [(ngModel)]="note"></textarea>

    </div>
  </ng-container>
</nz-modal>

<!-- Add doctor -->

<nz-modal nzMaskClosable="false" [(nzVisible)]="modHospitalizationDetails" nzTitle="Add Hospitalization Details"
  (nzOnCancel)="modHospitalizationDetails=false" (nzOnOk)="modHospitalizationDetails=false" nzOkText="Add"
  nzWidth="75%">
  <ng-container *nzModalContent>
    <!-- Search and add Hospitalization -->
    <div>
      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="medicine-box" nzTheme="outline"></i> Hospitalization</h3>
        <button nz-button nzType="primary" (click)="modSearchAddHosp=true;">
          Search / Add Hospital
        </button>
      </div>

      <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x: '1200'}">
        <thead>
          <tr>
            <th>Name of Hospital</th>
            <th>Location</th>
            <th>Address</th>
            <th>Admission Date</th>
            <th>Discharge Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Fort Speciality</td>
            <td>MUMBAI</td>
            <td>Grand Trunk Road, Marine Drive, KD 2910</td>
            <td>
              <nz-date-picker style="width:100%"></nz-date-picker>
            </td>
            <td>
              <nz-date-picker style="width:100%"></nz-date-picker>
            </td>
            <td>
              <a class="mutates-data does-edit" (click)="modSearchAddHosp=true">Edit</a> |
              <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
                nzCancelText="Cancel">Remove</a>
            </td>
          </tr>
        </tbody>
      </nz-table>

      <div class="heading-tab">
        <h3 class="heading"><i nz-icon nzType="reconciliation" nzTheme="outline"></i> Treating Doctor Details</h3>
        <button nz-button nzType="primary" (click)="modSearchAddDoctor=true">Search / Add Doctor</button>
      </div>

      <nz-table [nzData]="dataSet" [nzShowPagination]="false">
        <thead>
          <tr>
            <th>Doctor Name</th>
            <th>Speciality</th>
            <th>Regn. Details</th>
            <th>Treated For</th>
            <th>Remarks</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr class="v-a-top">
            <td>Dr. John Dorian</td>
            <td>Heart Surgeon</td>
            <td>RGNF09993883</td>
            <td><input type="text" nz-input ngModel="Angioplasty"></td>
            <td><textarea nz-input cols="30" rows="2" placeholder="Notes for Critical Illness Benefit"></textarea>
            </td>
            <td>
              <a class="mutates-data does-edit" (click)="modSearchAddDoctor=true">Edit</a> |
              <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
                nzCancelText="Cancel">Remove</a>
            </td>
          </tr>
          <tr class="v-a-top">
            <td>Dr. Rakesh Gupta</td>
            <td>General Practitioner</td>
            <td>RGNF09993883</td>
            <td><input type="text" nz-input ngModel="Sudden chest pain"></td>
            <td><textarea nz-input cols="30" rows="2"
                placeholder="Notes for Critical Illness Benefit">No complications</textarea></td>
            <td>
              <a class="mutates-data does-edit" (click)="modSearchAddDoctor=true">Edit</a> |
              <a class="mutates-data does-delete" nz-popconfirm nzPopconfirmTitle="Remove entry?" nzOkText="Remove"
                nzCancelText="Cancel">Remove</a>
            </td>
          </tr>
        </tbody>
      </nz-table>

    </div>
    <!-- MODAL Search and add Doctor -->
    <nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchAddDoctor" nzTitle="Doctor Details"
      (nzOnCancel)="modSearchAddDoctor=false" (nzOnOk)="modSearchAddDoctor=false" nzOkText="Add" nzWidth="75%">
      <ng-container *nzModalContent>
        <div *ngIf="modSearchAddDoctor">

          <nz-radio-group [(ngModel)]="tabDoc" [nzButtonStyle]="'solid'" [nzSize]="'default'">
            <label nz-radio-button nzValue="search-doc">
              <i nz-icon nzType="user" nzTheme="outline"></i> Search Doctor
            </label>
            <label nz-radio-button nzValue="add-doc">
              <i nz-icon nzType="user-add" nzTheme="outline"></i> Add New Doctor
            </label>
          </nz-radio-group>

          <!-- SEARCH DOC -->
          <div *ngIf="tabDoc=='search-doc'">
            <div class="tab-grid m-t-20 p-b-10">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Doctor Name</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Registration No.</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Location</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" ngModel="Mumbai" />
                </nz-form-control>
              </nz-form-item>
              <div>
                <button nz-button nzType="primary">Search</button>
              </div>
            </div>
            <nz-table [nzData]="dataSet" [nzShowPagination]="false">
              <thead>
                <tr>
                  <th></th>
                  <th>Doctor Name</th>
                  <th>Speciality</th>
                  <th>Regn. Details</th>
                  <th>Location</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr class="v-a-top">
                  <td><label nz-checkbox nzValue="true"></label></td>
                  <td>Dr. John Dorian</td>
                  <td>Heart Surgeon</td>
                  <td>RGNF09993883</td>
                  <td>Mumbai</td>
                  <td>
                    <a class="mutates-data does-edit" (click)="modDocDetails=true">Edit</a>
                  </td>
                </tr>
                <tr class="v-a-top">
                  <td><label nz-checkbox nzValue="true"></label></td>
                  <td>Dr. Rakesh Gupta</td>
                  <td>General Practitioner</td>
                  <td>RGNF09993883</td>
                  <td>Mumbai</td>
                  <td>
                    <a class="mutates-data does-edit" (click)="modDocDetails=true">Edit</a>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>

          <!-- ADD DOC -->
          <div *ngIf="tabDoc=='add-doc'">

            <div class="tab-grid m-t-20 p-b-10">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Doctor Name</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Registration No.</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Location</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" ngModel="Mumbai" />
                </nz-form-control>
              </nz-form-item>
            </div>

          </div>

        </div>
      </ng-container>
    </nz-modal>

    <!-- MODAL Search and add Hospital -->
    <nz-modal nzMaskClosable="false" [(nzVisible)]="modSearchAddHosp" nzTitle="Hospital Details"
      (nzOnCancel)="modSearchAddHosp=false" (nzOnOk)="modSearchAddHosp=false" nzOkText="Add" nzWidth="75%">
      <ng-container *nzModalContent>
        <div *ngIf="modSearchAddHosp">

          <nz-radio-group [(ngModel)]="tabHosp" [nzButtonStyle]="'solid'" [nzSize]="'default'">
            <label nz-radio-button nzValue="search-hosp">
              Search Hospital
            </label>
            <label nz-radio-button nzValue="add-hosp">
              Add New Hospital
            </label>
          </nz-radio-group>

          <!-- SEARCH HOSPITAL -->
          <div *ngIf="tabHosp=='search-hosp'">
            <div class="tab-grid m-t-20 p-b-10">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Hospital Name</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Location</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" ngModel="Mumbai" />
                </nz-form-control>
              </nz-form-item>
            </div>
            <div>
              <button nz-button nzType="primary">Search</button>
            </div>
            <nz-table [nzData]="dataSet" [nzShowPagination]="false" [nzScroll]="{x: '1200'}">
              <thead>
                <tr>
                  <th></th>
                  <th>Name of Hospital</th>
                  <th>Location</th>
                  <th>Address</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <nz-radio-group [(ngModel)]="selectedHosp">
                      <label nz-radio nzValue="A"></label>
                    </nz-radio-group>
                  </td>
                  <td>Fort Speciality</td>
                  <td>MUMBAI</td>
                  <td>Grand Trunk Road, Marine Drive, KD 2910</td>
                  <td>
                    <a class="mutates-data does-edit" (click)="modHospDetails=true">Edit</a>
                  </td>
                </tr>
                <tr>
                  <td>
                    <nz-radio-group [(ngModel)]="selectedHosp">
                      <label nz-radio nzValue="B"></label>
                    </nz-radio-group>
                  </td>
                  <td>PV Hospital</td>
                  <td>MUMBAI</td>
                  <td>Vista 494, South KR, Fort</td>
                  <td>
                    <a class="mutates-data does-edit" (click)="modHospDetails=true">Edit</a>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>

          <!-- ADD HOSPITAL -->
          <div *ngIf="tabHosp=='add-hosp'">
            <div class="tab-grid m-t-20 p-b-10">
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Hospital Name</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Speciality</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Location</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <input nz-input placeholder="" ngModel="Mumbai" />
                </nz-form-control>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label [nzSpan]="24">Address</nz-form-label>
                <nz-form-control [nzSpan]="24">
                  <textarea nz-input nzAutosize placeholder="Address"></textarea>
                </nz-form-control>
              </nz-form-item>

            </div>

          </div>

        </div>
      </ng-container>
    </nz-modal>
    <!-- / Search and add Hospitalication -->
  </ng-container>
</nz-modal>







<!-- Hidden Content -- DRAWERS -->
<!-- CORRESPONDENCE -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Correspondence with `Chris Hemsworth`"
  [nzVisible]="corresPanelOpen" (nzOnClose)="corresPanel(0)">
  <ng-container *nzDrawerContent>
    <div>

      <div class="p-b-10 flex flex-horiz-space-bw">
        <div></div>
        <button nz-button nzType="primary" (click)="openCorrModal()">New Correspondence</button>
      </div>

      <nz-timeline>
        <nz-timeline-item nzColor="green">
          <h4 class="f-w-600">eMail <nz-tag [nzColor]="'green'">Sent</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            To: riya@gmail.com <br>
            Message: Your claim is being processed <br>
            Attachment: <a>CLM0000107.EML</a>
          </p>
        </nz-timeline-item>
        <nz-timeline-item nzColor="green">
          <h4 class="f-w-600">SMS <nz-tag [nzColor]="'green'">Sent</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            To: 9809862272 <br />
            Message: Your claim is being processed
          </p>
        </nz-timeline-item>
      </nz-timeline>
    </div>
  </ng-container>
</nz-drawer>

<!-- DOCUMENT PANEL // DOCUMENT MANAGER -->
<nz-drawer [nzClosable]="true" [nzWidth]="460" [nzPlacement]="'right'" nzTitle="Document Manager"
  [nzVisible]="docuPanelOpen" (nzOnClose)="docuPanel(0)">
  <ng-container *nzDrawerContent>
    <div>
      <app-document-manager [requirements]="_inputDocumentManagerComponent['requirementDOs']"
        [inputDataForEdit]="_inputDocumentManagerComponent['entityDocumentDOs']"
        [RequirementEntityGuid]="transactionGuid"
        (componentOutput)="_BaseEmitHandler($event, 'DocumentManagerComponent')">
      </app-document-manager>
    </div>
  </ng-container>
</nz-drawer>

<!-- PENDING TASKS -->
<nz-drawer [nzClosable]="true" [nzWidth]="390" [nzPlacement]="'right'" nzTitle="Pending Tasks for #CLM0000107"
  [nzVisible]="pendingPanelOpen" (nzOnClose)="pendingPanel(0)">
  <ng-container *nzDrawerContent>
    <div *ngIf="pendingPanelOpen">

      <nz-timeline>
        <nz-timeline-item nzColor="orange">
          <h4 class="f-w-600">Investigation <nz-tag [nzColor]="'orange'">Pending</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            Investigator: G. Fadango <br>
            Status: Being Investigated
          </p>
        </nz-timeline-item>
        <nz-timeline-item nzColor="orange">
          <h4 class="f-w-600">Missing Document <nz-tag [nzColor]="'orange'">Pending</nz-tag>
          </h4>
          <p><i class="anticon anticon-calendar"></i>5 Apr 2019 10:12 AM (5 days ago)</p>
          <p>
            Notes: Correspondence sent to Claimant
          </p>
        </nz-timeline-item>
      </nz-timeline>

    </div>
  </ng-container>

</nz-drawer>
<!-- END Hidden Content -->